module.exports = ({
    'SM810H005': 'ข้อมูล',
    'SM810OTP001': 'ไม่ต้องแสดงกล่องโต้ตอบนี้อีก',
})